import { ValidationError } from "joi";

const findError = (path: string, errors?: ValidationError) => {
	return errors?.details?.find((item) => item.message.includes(path));
};

export default findError;
